import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@nx/angular';
import * as ShipmentActivitiesActions from './shipment-activities.actions';
import * as ShipmentActivitiesSelectors from './shipment-activities.selectors';
import { ShipmentActivitiesServiceBase } from './../shipment-activities-service-base';
import { map, tap, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ShipmentActivitiesEffects {
    init$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShipmentActivitiesActions.init),
            fetch({
                run: action => {
                    return this.service
                        .getShipmentActivities(action.shipmentId, 1)
                        .pipe(
                            map(({ data, meta }) =>
                                ShipmentActivitiesActions.loadShipmentActivitiesSuccess(
                                    {
                                        shipmentActivities: data,
                                        pagination: meta,
                                    }
                                )
                            )
                        );
                },

                onError: (action, error) => {
                    console.error(error);
                    return ShipmentActivitiesActions.loadShipmentActivitiesFailure(
                        { error }
                    );
                },
            })
        )
    );

    loadMoreShipmentActivities$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShipmentActivitiesActions.loadMoreShipmentActivities),
            withLatestFrom(
                this.store.select(
                    ShipmentActivitiesSelectors.getShipmentActivitiesPagination
                )
            ),
            fetch({
                run: (action, pagination) => {
                    return this.service
                        .getShipmentActivities(
                            action.shipmentId,
                            pagination.current_page + 1
                        )
                        .pipe(
                            map(({ data, meta }) =>
                                ShipmentActivitiesActions.loadMoreShipmentActivitiesSuccess(
                                    {
                                        shipmentActivities: data,
                                        pagination: meta,
                                    }
                                )
                            )
                        );
                },

                onError: (action, error) => {
                    console.error(error);
                    return ShipmentActivitiesActions.loadMoreShipmentActivitiesFailure(
                        { error }
                    );
                },
            })
        )
    );

    createShipmentActivitiesComment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShipmentActivitiesActions.createShipmentActivitiesComment),
            fetch({
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                run: (action, _) => {
                    return this.service
                        .createComment(action.shipmentId, action.payload)
                        .pipe(
                            map(shipmentActivity =>
                                ShipmentActivitiesActions.createShipmentActivitiesCommentSuccess(
                                    { shipmentActivity }
                                )
                            )
                        );
                },

                onError: (action, error) => {
                    console.error(error);
                    return ShipmentActivitiesActions.createShipmentActivitiesCommentFailure(
                        { error }
                    );
                },
            })
        )
    );

    genericFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(
                    ShipmentActivitiesActions.createShipmentActivitiesCommentFailure,
                    ShipmentActivitiesActions.loadMoreShipmentActivitiesFailure
                ),
                tap(action => {
                    this.toastr.error(
                        action.error?.error?.message ??
                            "We're sorry, try again later or contact support if the problem persists",
                        'Something went wrong'
                    );
                })
            ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private service: ShipmentActivitiesServiceBase,
        private store: Store,
        private toastr: ToastrService
    ) {}
}
